export default "__VITE_ASSET__6e5ecac5__"